import { render, staticRenderFns } from "./emailMetrics.vue?vue&type=template&id=6de87e22&scoped=true&"
import script from "./emailMetrics.vue?vue&type=script&lang=js&"
export * from "./emailMetrics.vue?vue&type=script&lang=js&"
import style0 from "./emailMetrics.vue?vue&type=style&index=0&id=6de87e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de87e22",
  null
  
)

export default component.exports